<template>
  <div class="w1200">
    <el-breadcrumb separator="/" class="breadcrumb" v-if="isList">
      <el-breadcrumb-item v-for="(b, i) in breadcrumb1" :key="'breadcrumb' + i"
        ><span @click="goResource(i)">{{ b }}</span></el-breadcrumb-item
      >
    </el-breadcrumb>
    <div
      class="bg1 fl w240"
      style="position: absolute; top: 44px; height: calc(100% - 57px); overflow: auto"
    >
      <div class="hd ys4">
        <h3 v-if="isList">{{ breadcrumb1[1] }}资源</h3>
        <div class="tag">
          <el-tag
            v-for="(b, i) in breadcrumb1.slice(2, breadcrumb1.length)"
            :key="'mlbq' + i"
            @click="goResource(i + 1)"
            >{{ b }}<i class="el-icon-close"></i
          ></el-tag>
        </div>
        <el-tree
          v-if="treeShow"
          :props="defaultProps"
          :data="tree"
          @node-click="treeClick"
          highlight-current
          ><span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span></span
          ></el-tree
        >
        <span v-else>暂无数据</span>
      </div>
    </div>
    <div class="bg fr w940">
      <el-form ref="form" :model="search" label-width="120px" size="small">
        <el-form-item label="资源名称：">
          <el-input
            v-model="search.resourceName"
            style="width: 250px"
            placeholder="请输入搜索资源名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源类型：">
          <el-radio-group v-model="search.resourceTypeId">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              v-for="(resource, i) in resourceTypeData"
              :key="'resource' + i"
              :label="resource.code"
              >{{ resource.name }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文档类型：">
          <el-radio-group v-model="search.fileType">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              v-for="(resource, i) in fileTypeData"
              :key="'resource' + i"
              :label="resource.key"
              >{{ resource.value }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="共享学校：">
          <el-input
            v-model="search.orgName"
            style="width: 250px"
            placeholder="请输入搜索学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item :label="'作' + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + '者：'">
          <el-input
            v-model="search.userName"
            style="width: 250px"
            placeholder="请输入作者名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="共享年份：">
          <el-select v-model="search.year" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in yearData"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData()">查询</el-button>
          <el-button
            plain
            @click="
              search = {
                resourceName: '',
                resourceTypeId: '',
                fileType: '',
                orgName: '',
                userName: '',
                year: '',
              }
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="bg fr w940">
      <div style=""></div>
      <el-radio-group v-model="sortOrder" @change="getData()" size="small">
        <el-radio-button label="最新">最新<i class="el-icon-bottom"></i></el-radio-button>
        <el-radio-button label="下载量"
          >下载量<i class="el-icon-bottom"></i
        ></el-radio-button>
        <el-radio-button label="收藏量"
          >收藏量<i class="el-icon-bottom"></i
        ></el-radio-button>
      </el-radio-group>
      <el-divider style="margin-top: 10px"></el-divider>
      <div class="bd ys4" style="min-height: 520px">
        <ul v-if="data.length > 0">
          <li v-for="(d, i) in data" :key="i">
            <div class="icon">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#icontbd' + d.fileType"></use>
              </svg>
              <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                >- {{ d.filePage }}页 -</em
              >
            </div>
            <div class="title">
              <h5 @click="yulan(d, 1)">{{ d.resourceName }}</h5>
              <span class="catalog">
                <i class="ka">{{ d.resourceTypeName }}</i>
                <i v-if="d.versionName">{{ d.versionName }}</i>
                <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
              </span>
              <div>
                <span class="attribute">时间：{{ d.createTime.split(" ")[0] }}</span>
                <span class="attribute">下载量：{{ d.downloadNumber }}</span>
                <span class="attribute">收藏量：{{ d.favoriteNumber }}</span>
                <span class="attribute">浏览量：{{ d.visitedNumber }}</span>
                <span class="attribute">大小：{{ unit(d.fileSize) }}</span>
              </div>

              <span class="attribute">学校：{{ d.schoolName }}</span>
              <span class="attribute">作者：{{ d.createUserName }}</span>
            </div>
            <div class="operate">
              <el-button type="primary" size="mini" @click="downLoad(d, 1)"
                >下载</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="cancelShare(d.resourceId)"
                v-if="
                  userModule.roles.filter((el) => el.id == 'AreaManager').length > 0 ||
                  userModule.roles.filter((el) => el.id == 'Auditor').length > 0
                "
                >取消共享</el-button
              >
              <el-button
                v-if="d.isFavorite == 'Y'"
                type="text"
                size="mini"
                style="padding-top: 0"
                @click="favorite(d)"
                >收藏</el-button
              >
            </div>
          </li>
        </ul>
        <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.pageAll"
          :page-size="pages.pageSize"
        ></el-pagination>
      </div>
    </div>
    <div class="cl"></div>
    <!-- <form id='downLoadForm' style='display:none' method='post' action='http://cssz.hwxxkj.com:4283/uploader1/DownloadFile<input type='hidden' name='token' value='Y900VF33veQcMCNwTdeiBXjFNIe0vQlG'><input type='hidden' name='clientId' value='9303800555'><input type='hidden' name='Path' value='/uploader1/9303800555/2020/11/12/d10c6921a4fe471e8f9218a2a6a93172/图片.jpg'></form> -->
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import link from "../../mixins/link";
import yulan from "../../mixins/yulan";
import downLoad from "../../mixins/downLoad";
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      search: {
        resourceName: "",
        resourceTypeId: "",
        fileType: "",
        orgName: "",
        userName: "",
        year: "",
      },
      resourceTypeData: [],
      fileTypeData: [],
      yearData: [],
      sortOrder: "最新",
      data: [],
      treeShow: false,
      clickData: {},
      breadcrumb1: [],
      previewUrl: "",
      uploadUrl: "",
      tree: [],
      pages: {
        pageIndex: 1,
        pageAll: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState(["userModule"]),
  },
  mixins: [link, yulan, downLoad],
  props: {
    sectionData: { type: Array },
    breadcrumb: { type: Array },
    activeName: { type: String },
    breadcrumbData: { type: Object },
    init1: { type: Number },
    isList: { type: Boolean, default: true },
    searchName: { type: String, default: "" },
    searchTypeId: { type: String, default: "" },
  },
  watch: {
    init1: {
      handler(n, o) {
        if (n != 0) {
          this.init();
        }
        // this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    handleSizeChange(v) {
      this.pages.pageIndex = 1;
      this.pages.pageSize = v;
      this.getData(1, v);
    },
    // 分页页码变动
    handleCurrentChange(v) {
      this.pages.pageIndex = v;
      this.getData(v);
    },
    search1() {
      this.search.resourceName = this.searchName;
      this.search.resourceTypeId = this.searchTypeId;
      this.getData();
    },
    init() {
      this.sortOrder = this.$route.params.sortOrder
        ? this.$route.params.sortOrder
        : "最新";
      this.search.resourceTypeId = this.$route.params.resourceTypeId
        ? this.$route.params.resourceTypeId
        : "";
      this.search.resourceName = this.$route.params.resourceName
        ? this.$route.params.resourceName
        : "";
      if (
        this.$route.params.sectionId &&
        this.$route.params.subjectId &&
        this.$route.params.sectionName &&
        this.$route.params.subjectName
      ) {
        this.breadcrumb1 = [
          "资源平台",
          this.$route.params.sectionName + this.$route.params.subjectName,
        ];
        this.clickData = {
          sectionId: this.$route.params.sectionId,
          sectionName: this.$route.params.sectionName,
          subjectId: this.$route.params.subjectId,
          subjectName: this.$route.params.subjectName,
        };
      } else {
        this.breadcrumb1 = this.breadcrumb;
        this.clickData = this.breadcrumbData;
      }

      this.getSearch();
      this.getData();
      this.previewUrl = window.sessionStorage.getItem("previewUrl");
      this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
      this.tree = JSON.parse(window.sessionStorage.getItem("sectionData"));
      if (this.clickData.sectionId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.sectionId
        )[0].children;
      }
      if (this.clickData.subjectId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.subjectId
        )[0].children;
      }
      if (this.clickData.versionId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.versionId
        )[0].children;
      }
      if (this.clickData.volumeId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.volumeId
        )[0].children;
      }
      setTimeout(() => {
        this.treeShow = true;
      }, 10);
    },
    treeClick(d, n, a) {
      this.clickData = n.data;
      this.clickData.relationDataId = n.data.dataId;
      // this.clickData.volumeId = n.data.dataId;
      let section = this.sectionData.filter((el) => el.id == n.data.sectionId)[0];
      let subject = section.children.filter((el) => el.id == n.data.subjectId)[0];
      if (n.data.type == "chapter") {
        if (this.breadcrumb1.length + n.level - 4 == 1) {
          this.clickData.firstChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 2) {
          this.clickData.firstChapterId = n.parent.data.id;
          this.clickData.secondChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 3) {
          this.clickData.firstChapterId = n.parent.parent.data.id;
          this.clickData.secondChapterId = n.parent.data.id;
          this.clickData.thirdChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 4) {
          this.clickData.firstChapterId = n.parent.parent.parent.data.id;
          this.clickData.secondChapterId = n.parent.parent.data.id;
          this.clickData.thirdChapterId = n.parent.data.id;
          this.clickData.fourthChapterId = n.data.id;
        }
        this.getData();
        return false;
      }
      // this.getData();
      // if (n.data.leaf) {
      //   return false;
      // }

      if (n.data.type == "version") {
        this.treeShow = false;
        window.sessionStorage.setItem(
          "currentDirectory",
          JSON.stringify({
            sectionId: n.data.sectionId,
            sectionName: section.label,
            subjectId: n.data.subjectId,
            subjectName: subject.label,
            versionId: n.data.versionId,
            versionName: n.data.label,
            gradeId: "",
            volumeId: "",
            relationDataId: "",
            chapterId: "",
          })
        );
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify(["资源平台", section.label + subject.label, n.data.label])
        );
        this.$emit("replace");
      } else if (n.data.type == "volume") {
        this.treeShow = false;
        let c = this.breadcrumb1.length == 2 ? n.parent.data.label : this.breadcrumb1[2];
        window.sessionStorage.setItem(
          "currentDirectory",
          JSON.stringify({
            sectionId: n.data.sectionId,
            sectionName: section.label,
            subjectId: n.data.subjectId,
            subjectName: subject.label,
            versionId: n.data.versionId,
            versionName: c,
            gradeId: "",
            volumeId: n.data.id,
            volumeName: n.data.label,
            relationDataId: "",
            chapterId: "",
          })
        );
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify(["资源平台", section.label + subject.label, c, n.data.label])
        );
        this.$emit("replace");
      }
    },
    goResource(v) {
      let a = {
        sectionId: "",
        sectionName: "",
        subjectId: "",
        subjectName: "",
        versionId: "",
        versionName: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        chapterId: "",
      };
      let b = [];
      if (v == 0) {
        let c = JSON.parse(window.sessionStorage.getItem("sectionData"));
        a.sectionId = c[0].id;
        a.sectionName = c[0].label;
        a.subjectId = c[0].children[0].label;
        a.subjectName = c[0].children[0].label;
        this.$router.push({ name: "IndexPage" });
        window.sessionStorage.setItem("currentDirectory", JSON.stringify(a));
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify(["资源中心", a.sectionName + a.subjectName])
        );
        return false;
      }
      if (v > 0) {
        a.sectionId = this.breadcrumbData.sectionId;
        a.sectionName = this.breadcrumbData.sectionName;
        a.subjectId = this.breadcrumbData.subjectId;
        a.subjectName = this.breadcrumbData.subjectName;
        b = ["资源中心", a.sectionName + a.subjectName];
      }
      if (v > 1) {
        a.versionId = this.breadcrumbData.versionId;
        a.versionName = this.breadcrumbData.versionName;
        b = ["资源中心", a.sectionName + a.subjectName, a.versionName];
      }
      if (v > 2) {
        a.volumeId = this.breadcrumbData.volumeId;
        a.volumeName = this.breadcrumbData.volumeName;
        b = ["资源中心", a.sectionName + a.subjectName, a.versionName, a.volumeName];
      }
      if (v > 3) {
        a.chapterId = this.breadcrumbData.chapterId;
        a.chapterName = this.breadcrumbData.chapterName;
        b = [
          "资源中心",
          a.sectionName + a.subjectName,
          a.versionName,
          a.volumeName,
          a.chapterName,
        ];
      }
      this.treeShow = false;
      window.sessionStorage.setItem("currentDirectory", JSON.stringify(a));
      window.sessionStorage.setItem("breadcrumb", JSON.stringify(b));
      this.$emit("replace");
    },
    async loadNode(node, resolve) {
      let url;
      let sectionId;
      let subjectId;
      let versionId;
      let dataId;
      let chapterId;
      if (node.level == 0) {
        url =
          this.breadcrumb1.length == 2
            ? "/common/catalog/load/version"
            : this.breadcrumb1.length == 3
            ? "/common/catalog/load/volume"
            : this.breadcrumb1.length == 4
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = this.breadcrumbData.sectionId;
        subjectId = this.breadcrumbData.subjectId;
        versionId =
          this.breadcrumb1.length < 3
            ? node.data
              ? node.data.versionId
              : ""
            : this.breadcrumbData.versionId;
        dataId =
          this.breadcrumb1.length < 4
            ? node.data
              ? node.data.dataId
              : ""
            : this.breadcrumbData.volumeId;
        chapterId = node.data ? node.data.chapterId : "";
      } else {
        url =
          node.data.type == "version"
            ? "/common/catalog/load/volume"
            : node.data.type == "volume"
            ? "/common/catalog/load/chapter"
            : node.data.type == "chapter"
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = node.data.sectionId;
        subjectId = node.data.subjectId;
        versionId = node.data.versionId;
        dataId = node.data.dataId;
        chapterId = node.data.node;
      }
      let a = await this.$ajax.post(url, {
        sectionId: sectionId,
        subjectId: subjectId,
        versionId: versionId,
        chapterId: chapterId,
        dataId: dataId,
      });
      a.map((el) => {
        el.leaf = el.childCount == 0;
      });
      return resolve(a);
    },
    getData() {
      let p = { page: this.pages.pageIndex, size: this.pages.pageSize };
      Object.assign(p, this.search, this.clickData);
      let url =
        this.sortOrder == "最新"
          ? "/server/resource/center/listByDate"
          : this.sortOrder == "下载量"
          ? "/server/resource/center/listByDownload"
          : "/server/resource/center/listByFavorite";
      this.$ajax.post(url, p).then((res) => {
        this.data = res.list;
        this.pages.pageAll = res.total;
      });
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    getSearch() {
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.resourceTypeData = res;
      });
      this.$ajax.post("/common/load/share/year").then((res) => {
        this.yearData = res;
      });
      this.$ajax.post("/common/load/file/type").then((res) => {
        this.fileTypeData = res;
      });
    },
    cancelShare(id) {
      this.$ajax
        .post("/server/resource/common/cancelShare", {
          resourceId: id,
        })
        .then((res) => {
          this.data = this.data.filter((el) => el.resourceId != id);
        });
    },
    downloadFile(url, fileName) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = function (e) {
        //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },

    favorite(d) {
      this.$ajax
        .post("/server/resource/common/favorite", { resourceId: d.resourceId })
        .then((res) => {
          d.isFavorite = "N";
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/resource/index1.vue